export default __webpack_public_path__ + "static/media/world.c1f1dea3.gif";